import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';
import classes from './inventory.module.scss';
import Loader from '../../../_common/Loader/Loader';
import { getInventoryRequest } from '../../../../store/actions/products';
import accountHelpers from '../../../../utils/accountHelpers';
import Button from '../../../_common/Form/Buttons/Button';
import { RangeDatePicker } from '../../../_common/Form/DatePickers/RangeDatePicker/RangeDatePicker';
import { useQuery } from '../../../../utils/hooks/useQuery';
import api from '../../../../api/api';

const header = ['Date', 'Reason', 'Change', 'Balance', 'Patient', 'RX', 'Memo', 'Lot', 'Expires'];

const thisMonthStartDay = moment().startOf('month').format('YYYY-MM-DD');
const thisMonthEndDate = moment().format('YYYY-MM-DD');
const Inventory = () => {
  const dispatch = useDispatch();
  const { productId } = useParams();
  const navigate = useNavigate();
  const { query, setQuery } = useQuery();

  const { inventoryList, requestStatus } = useSelector((store) => store.products);

  const [inventory, setInventory] = useState([]);
  const [requestData, setRequestData] = useState({
    start: query.start || thisMonthStartDay,
    end: query.start && !query.end ? '' : query.end || thisMonthEndDate,
    productId,
    userId: accountHelpers.getUser().id,
  });
  const [downloadLoad, setDownloadLoad] = useState(false);

  useEffect(() => {
    (() => {
      dispatch(getInventoryRequest(requestData));

      setQuery({ start: requestData.start, end: requestData.end });
    })();
  }, [requestData]);

  useEffect(() => {
    if (requestStatus === 'success') {
      setInventory(_.orderBy([
        ...inventoryList[0].productAdjustments,
        ...inventoryList[0].Scripts,
        ...inventoryList[0].productOrders,
      ], (inv) => new Date(inv.processedOn || inv.orderDate), 'desc'));
    }
  }, [requestStatus]);

  const onChangeDate = (currentDate) => {
    setRequestData((prev) => ({ ...prev, start: currentDate[0], end: currentDate[1] }));
  };

  const clearFilters = () => {
    setRequestData((prev) => ({ ...prev, start: thisMonthStartDay, end: thisMonthEndDate }));
  };
  const downloadFile = async () => {
    setDownloadLoad(true);

    await api.getInventory({
      ...requestData,
      download: true,
    });

    setDownloadLoad(false);
  };

  return (

    <div className={classes.table_pagination_wrapper}>
      <div className={classes.title}>
        <div className={classes.title_left_block}>
          <h2>Inventory</h2>

          <div className={classes.calendar}>
            <RangeDatePicker
              currentDate={requestData}
              onChangeDate={onChangeDate}
            />
          </div>

          <div style={{ width: 160, marginRight: 15 }}>
            <Button
              title="Clear"
              clearButton
              onClick={clearFilters}
            />
          </div>
        </div>

        <Button
          title="Download"
          downloadButton
          onClick={downloadFile}
          loading={downloadLoad}
        />
      </div>

      { requestStatus === 'request'
        ? (
          <div className={classes.loading_wrapper}>
            <Loader />
          </div>
        )
        : requestStatus === 'success' && !inventory.length
          ? <div className={classes.notResult}>No Data Found</div>

          : (
            <div className={classes.table_wrapper}>

              <table>

                <thead>
                  <tr>
                    {header.map((h) => (
                      <th key={h}>{h}</th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {inventory.map((d) => {
                    const id = d.ScriptId || d.AdjustId || d.OrderId;

                    const url = d.ScriptId ? `/scripts/${id}`
                      : d.AdjustId ? `/products/adjustments/${id}`
                        : `/products/orders/${id}`;

                    return (
                      <tr key={id} onClick={() => navigate(url)}>
                        <td>
                          {moment(d.processedOn || d.orderDate).format('MM/DD/YYYY')}
                        </td>

                        <td>
                          { d.ScriptId ? 'Shipped' : d.AdjustId ? 'Adjusted' : 'Ordered'}
                        </td>

                        <td>
                          { d.quantity ? d.quantity : d.qtyChange}
                        </td>

                        <td>{inventoryList[0].quantity || '-'}</td>

                        <td>{d.ScriptId ? `${d.Patient.firstName} ${d.Patient.lastName}` : '-'}</td>

                        <td>{d.rxNumber || '-'}</td>

                        <td>{d.memo || '-'}</td>

                        <td>{d.lot || '-'}</td>

                        <td>
                          {
                             d.expiration ? moment(d.expiration).format('MM/DD/YYYY') : '-'
                            }
                        </td>

                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

    </div>
  );
};

Inventory.propTypes = {

};

export default Inventory;
